module.exports = __webpack_public_path__ + "static/img/white-logo-strip.c0ac4e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-logo-strip.svg
// module id = 3267
// module chunks = 1